import styled, { css } from 'styled-components';
import { reviewFontText } from 'components/mixins/reviewTypography';
import { bounce } from 'components/mixins/interactivity';
import { transparentize } from 'utils/color';

export const CommentFormContainer = styled.div`
  width: 100%;
`;

export const FormTitle = styled.h3`
  ${reviewFontText};
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 24px;
  text-align: left;
`;

type CommentTextareaProps = {
  ariaLabel: string;
  validComment: boolean;
}
export const CommentTextarea = styled.textarea.attrs((props: CommentTextareaProps) => ({
  'aria-label': props.ariaLabel
})) <CommentTextareaProps>`
  ${reviewFontText};
  display: block;
  width: 100%;
  height: 136px;
  max-height: 136px;
  padding: 12px;
  margin-bottom: 4px;
  resize: none;
  border: 1px solid #eaedf1;
  border-radius: 2px;
  outline: none;
  font-size: 12px;
  line-height: 20px;

  &:hover {
    border-color: #76b6e0;
  }

  &:focus {
    outline: none;
    border-color: #469dd5;
    box-shadow: inset 0 1px 3px 0 rgba(70, 157, 213, 0.3);
  }

  ${props =>
    !props.validComment &&
    css`
      & {
        background-color: ${transparentize(props.theme.colors.textColor, 0.02)};
        box-shadow: inset 0 2px 0 0 ${transparentize(props.theme.colors.incorrectColor, 0.06)};
        border: solid 1px ${props.theme.colors.incorrectColor};
        ${bounce};
      }
    `};
`;
